// V_DH_SITE_16 — Fall Sale Announcement Banner

(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function trackEvent(name) {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: name });
  }

  function init() {
    var banner = document.getElementById('c-site16-banner');
    if (!banner) return;

    // data-end is a Unix timestamp (seconds) worked out in the store's timezone by Liquid
    var end = Number(banner.getAttribute('data-end')) * 1000;
    var chips = {};
    banner.querySelectorAll('[data-unit]').forEach(function (el) {
      chips[el.getAttribute('data-unit')] = el;
    });

    var timer = null;

    // Live countdown: days / hours / minutes / seconds, ticking every second
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      chips.days.textContent = pad(Math.floor(s / 86400));
      chips.hours.textContent = pad(Math.floor((s % 86400) / 3600));
      chips.mins.textContent = pad(Math.floor((s % 3600) / 60));
      chips.secs.textContent = pad(s % 60);
      // Sale over: remove the banner; bring back the trust bar only if the fallback toggle is ON
      if (diff <= 0) {
        if (timer) clearInterval(timer);
        if (banner.getAttribute('data-fallback') === 'true') {
          var hideStyle = document.getElementById(banner.getAttribute('data-hide-style-id'));
          if (hideStyle) hideStyle.remove();
        }
        banner.remove();
      }
    }

    tick();
    timer = setInterval(tick, 1000);

    // sale_banner_view: once, when the banner is visible (it's hidden for Control)
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          trackEvent('sale_banner_view');
          observer.disconnect();
        }
      });
      observer.observe(banner);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
